import React from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
function selectValue(value, selected, all) {
  var at = all.indexOf(value);
  var updated = selected.slice(0, at).concat(value, selected.slice(at));
  // As inserting values at predefined index positions doesn't work with empty
  // arrays, we need to reorder the updated selection to match the initial order
  return updated.sort(function (a, b) {
    return all.indexOf(a) > all.indexOf(b);
  });
}
function deselectValue(value, selected) {
  return selected.filter(function (v) {
    return v !== value;
  });
}
function CheckboxesWidget(props) {
  var id = props.id,
    disabled = props.disabled,
    options = props.options,
    value = props.value,
    autofocus = props.autofocus,
    readonly = props.readonly,
    onChange = props.onChange;
  var enumOptions = options.enumOptions,
    inline = options.inline;
  var all = enumOptions.map(function (_ref) {
    var value = _ref.value;
    return value;
  });
  return /*#__PURE__*/_jsx("div", {
    className: "checkboxes",
    id: id,
    children: enumOptions.map(function (option, index) {
      var checked = value.indexOf(option.value) !== -1;
      var disabledCls = disabled || readonly ? ' disabled' : '';
      return /*#__PURE__*/_jsx("div", {
        id: "".concat(id, "_").concat(index),
        className: "checkbox checkbox-autoheight".concat(disabledCls).concat(checked ? ' selected' : ''),
        onClick: function onClick() {
          var newChecked = !checked;
          if (newChecked) {
            onChange(selectValue(option.value, value, all));
          } else {
            onChange(deselectValue(option.value, value));
          }
        },
        children: /*#__PURE__*/_jsx("label", {
          children: /*#__PURE__*/_jsx("span", {
            children: option.label
          })
        })
      }, "".concat(id, "_").concat(index));
    })
  }, id);
}
CheckboxesWidget.defaultProps = {};
if (process.env.NODE_ENV !== 'production') {
  CheckboxesWidget.propTypes = {
    schema: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    options: PropTypes.shape({
      enumOptions: PropTypes.array,
      inline: PropTypes.bool
    }).isRequired,
    value: PropTypes.any,
    required: PropTypes.bool,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func
  };
}
export default CheckboxesWidget;
//# sourceMappingURL=CheckboxesWidget.js.map